var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankVaults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96582 17.2676H15.6302V45.6176H7.96582V17.2676ZM27.8402 17.2676H20.1758V45.6176H27.8402V17.2676ZM40.0502 17.2676H32.3846V45.6176H40.0502V17.2676Z",
    fill: "#CED2DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 39.7676H3V45.6176H45V39.7676Z",
    fill: "#304FF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6302 39.7676H7.96582V45.6176H15.6302V39.7676ZM27.8402 39.7676H20.1758V45.6176H27.8402V39.7676ZM32.3846 39.7676H40.0502V45.6176H32.3846V39.7676Z",
    fill: "#101114"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11.4916V17.2672H45V11.4916L24 3.61719L3 11.4916ZM24 14.6176C24.4597 14.6176 24.9149 14.527 25.3395 14.3511C25.7642 14.1752 26.1501 13.9174 26.4752 13.5923C26.8002 13.2673 27.058 12.8814 27.2339 12.4567C27.4099 12.032 27.5004 11.5769 27.5004 11.1172C27.5004 10.6575 27.4099 10.2023 27.2339 9.77764C27.058 9.35295 26.8002 8.96707 26.4752 8.64203C26.1501 8.31699 25.7642 8.05915 25.3395 7.88324C24.9149 7.70733 24.4597 7.61679 24 7.61679C23.0716 7.61679 22.1813 7.98558 21.5248 8.64203C20.8684 9.29848 20.4996 10.1888 20.4996 11.1172C20.4996 12.0456 20.8684 12.9359 21.5248 13.5923C22.1813 14.2488 23.0716 14.6176 24 14.6176Z",
    fill: "#304FF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankVaults);
export default __webpack_public_path__ + "static/media/bank_vaults.b9debb9a853488cd0593e8dc626321b5.svg";
export { ForwardRef as ReactComponent };